import { render, staticRenderFns } from "./cart-features.vue?vue&type=template&id=1efe8fbb&scoped=true&"
import script from "./cart-features.vue?vue&type=script&lang=js&"
export * from "./cart-features.vue?vue&type=script&lang=js&"
import style0 from "./cart-features.vue?vue&type=style&index=0&id=1efe8fbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe8fbb",
  null
  
)

export default component.exports